<!-- KYMW4403 掲載商品グループ選択 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">掲載商品グループ</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <!-- FlexGird -->
        <wj-flex-grid #dtg_List [itemsSource]="model.list" [allowDragging]="'None'" horizontalScrollPolicy="on"
          [headersVisibility]="'Column'" [selectionMode]="'Row'" verticalScrollPolicy="on" [autoRowHeights]="true"
          forcedEnabledMode="true" [allowSorting]="false" [tabOrder]="0">
          <!-- column チェックボックス -->
          <wj-flex-grid-column [header]="' '" [width]="40" [binding]="'check'" [align]="'center'" [isReadOnly]="true" [minWidth]="5">
            <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
              <input #chk_Header id="chk_Header" type="checkbox" class="selected" (click)="$event.stopPropagation();headerCheck();"
                [tabindex]="-1" />
            </ng-template>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"
                [tabindex]="-1" />
            </ng-template>
          </wj-flex-grid-column>
          <!-- column 掲載商品グループ名 -->
          <wj-flex-grid-column [header]="'掲載商品グループ名'" [width]="292" [binding]="'name'"
            [isReadOnly]="true" [minWidth]="5"></wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button #btn_Set class="btn-primary" (click)="set()" [tabindex]="0" forcedEnabledMode="true">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>